import { render } from "./DashboardTab.vue?vue&type=template&id=bc22d32e&scoped=true&ts=true"
import script from "./DashboardTab.vue?vue&type=script&lang=ts"
export * from "./DashboardTab.vue?vue&type=script&lang=ts"

import "./DashboardTab.vue?vue&type=style&index=0&id=bc22d32e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc22d32e"]])

export default __exports__